import { render, staticRenderFns } from "./post-send.vue?vue&type=template&id=9329fbfc&scoped=true&"
import script from "./post-send.vue?vue&type=script&lang=js&"
export * from "./post-send.vue?vue&type=script&lang=js&"
import style0 from "./post-send.vue?vue&type=style&index=0&id=9329fbfc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9329fbfc",
  null
  
)

export default component.exports